import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
